import { ReactElement, useContext, useEffect, useState } from 'react';
import { initI18n } from './init';
import 'date-fns/locale/nl-BE';
import { SettingsContext } from '../../modules/app';

type Props = {
  children: ReactElement | null;
  loading: ReactElement | null;
};

export const I18nGate = ({ children, loading }: Props) => {
  const { settings } = useContext(SettingsContext);
  const [i18nReady, setI18nReady] = useState(false);

  useEffect(() => {
    if (!i18nReady && settings != null) {
      const domainLanguage: string =
        settings.domainMapping[window.location.hostname] || settings.fallbackLanguage;

      const currentURL = window.location.href;
      if (currentURL.indexOf('/nl/') !== -1) {
        const redirectUrl = currentURL.replace('/nl/', `/${domainLanguage}/`);
        window.location.replace(redirectUrl);
      }

      initI18n(domainLanguage, settings).then(() => setI18nReady(true));
    }
  }, [i18nReady, settings]);

  if (!i18nReady) {
    return loading;
  }

  return children;
};
